export enum ProductPageReferrerEnum {
  StorageProducts = 'storageProducts',
  MaintenanceComponent = 'maintenanceComponent',
  MaintenanceJob = 'maintenanceJob',
  DeactivatedJobs = 'deactivatedJobs',
}
